import { Ref, watch } from "vue";
import Konva from "konva";
import { getStagePosition, setReactPositionToList } from "./common";

const strokeWidth = 8;
const useLasso = (
  stage: Ref<Konva.Stage | null>,
  layer: Ref<Konva.Layer | null>,
  enable: Ref<boolean>,
  onCreated?: (line: Konva.Line) => void
) => {
  let isPaint = false;
  let line: Konva.Line;
  watch(
    [stage, layer],
    (val) => {
      const [newStage, newLayer] = val;
      if (!newStage || !newLayer) return;
      newStage.on("touchstart", function () {
        if (!enable.value) return;
        isPaint = true;
        const [x, y, scale] = getStagePosition(newStage, strokeWidth);
        line = new Konva.Line({
          stroke: "#fff",
          strokeWidth: strokeWidth / scale,
          // round cap for smoother lines
          lineCap: "round",
          lineJoin: "round",
          // add point twice, so we have some drawings even on a simple click
          points: [x, y, x, y],
          draggable: false,
          fill: "#fff",
          opacity: 0.4,
          // fillRule: "evenodd",
          closed: true,
          tension: 0.5,
        });
        newLayer.add(line);
        if (onCreated) {
          onCreated(line);
        }
      });
      newStage!.on("touchmove", function () {
        if (!isPaint) {
          return;
        }
        const [x, y] = getStagePosition(newStage, strokeWidth);
        const newPoints = line.points().concat([x, y]);
        line.points(newPoints);
      });

      newStage!.on("touchend", function () {
        isPaint = false;

        setReactPositionToList();
      });
    },
    { immediate: true }
  );
};

export default useLasso;
